import Mock from 'mockjs'

const {page} = require('../util');
const {complexEval} = require('./calculator-util');
const {leftData, rightData, targets, items} = require('./data');
const qs = require('qs');

let tempTargets = [];

Mock.mock('/left-data/findAll', 'post', ({url, type, body}) => {
    let bodyObject = qs.parse(body);
    console.log('mock请求 url: %s, body: %o', url, bodyObject);
    bodyObject.data = getLeftData();
    return {
        code: 200,
        body: bodyObject,
    }
});

Mock.mock('/right-data/findAll', 'post', ({url, type, body}) => {
    let bodyObject = qs.parse(body);
    console.log('mock请求 url: %s, body: %o', url, bodyObject);
    bodyObject.data = getRightData();
    return {
        code: 200,
        body: bodyObject,
    }
});

function getLeftData() {
    // console.log('getLeftData');
    let leftDataR = [];
    for (let i = 0; i < leftData.length; i++) {
        let each = leftData[i];
        let value = targetComplete(each.company);
        leftDataR.push({company: each.company, value: value});
    }
    console.log(JSON.stringify(leftDataR));
    return leftDataR;
}

function getRightData() {
    let rightDataR = [];
    for (let i = 0; i < rightData.length; i++) {
        let each = rightData[i];
        let list = targetCompleteCollection(each.company);
        rightDataR.push({company: each.company, value: list});
    }
    console.log(JSON.stringify(rightDataR));
    return rightDataR;
}

function targetComplete(company) {
    console.log('==================== targetComplete =======================');
    let value = 0;
    for (let i = 0; i < targets.length; i++) {
        let each = targets[i];
        let rule = each.ftype;
        let count = 0;
        let formula = getFormula(rule, count, company);
        let tempValue = complexEval(formula);
        if (tempValue) {
            tempValue = parseFloat(tempValue);
            if (tempValue < 1) {
                tempValue = tempValue * 100;
            }
            if (parseInt(tempValue) === 0) {
                tempValue = tempValue + 1;
            }
            value = value + parseInt(tempValue);
        }
        console.log('formula: %s, tempValue: %s, value: ', formula, tempValue, value);
    }
    return value;
}

function targetCompleteCollection(company) {
    console.log('==================== targetCompleteCollection =======================');
    let list = [];
    for (let i = 0; i < targets.length; i++) {
        let each = targets[i];
        let rule = each.ftype;
        let count = 0;
        let formula = getFormula(rule, count, company);
        let tempValue = complexEval(formula);
        if (tempValue) {
            tempValue = parseFloat(tempValue);
            if (tempValue < 1) {
                tempValue = tempValue * 100;
            }
            if (parseInt(tempValue) === 0) {
                tempValue = tempValue + 1;
            }
            list.push(tempValue);
        } else {
            list.push(0);
        }
        console.log('formula: %s, tempValue: %s, value: ', formula, tempValue, list);
    }
    return list;
}

function getFormula(str, count, company) {
    // console.log('getFormula');
    count++;
    if (count > 10) {
        return null;
    }
    str = str.replace(/ /g, '');
    // =======================================================
    let re = /Piecewise\(([\S]+?),/;
    let result = re.exec(str);
    let name;
    if (result) {
        name = result[1];
    }
    if (name) {
        let item = getItem(company, name);
        if (item) {
            // console.log('company: %o, name: %s, item: %o', company, name, item);
            return name.replace(name, item.value);
        } else return 0;
    }
    // ===========================================================================
    re = /(\$[\S]+?)([+\-*/()])/;
    result = re.exec(str);
    if (result === null) {
        re = /(\$[\S]+)/;
        result = re.exec(str);
        if (result === null) {
            // console.log('return str: %s', str);
            return str;
        }
    }
    name = result[1];
    if (name) {
        let item = getItem(company, name);
        if (item) {
            str = str.replace(name, item.value);
            console.log('company: %o, name: %s, item: %o, str: %s', company, name, item, str);
            return getFormula(str, count, company);
        } else {
            str = str.replace(name, 0);
            console.log('return company: %o, name: %s, item: %o, str: %s', company, name, item, str);
            return str;
        }
    } else {
        return str;
    }
}

function getItem(company, name) {
    // console.log('getItem');
    name = name.replace('$', '');
    return items.find(function (value, index, arr) {
        // console.log('find item: %o, company: %o, name: %s', value, company, name);
        return value.company.id === company.id && value.name === name;
    });
}
